/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.skills.SkillTriggerType
*/
export var SkillTriggerType;
(function (SkillTriggerType) {
    SkillTriggerType["PATTERN"] = "PATTERN";
    SkillTriggerType["KEYWORDS"] = "KEYWORDS";
})(SkillTriggerType || (SkillTriggerType = {}));
//# sourceMappingURL=SkillTriggerType.js.map